import { useTranslation } from "react-i18next";
import { useState } from "react";
import { getMedalsBySeason } from "../../data/medalsRepository.js";
import { getNationalTitlesBySeason } from "../../data/titlesRepository.js";
import MedagliereDetail from "./MedagliereDetail.jsx";

function MedagliereComponent({ medals, nationalTitles, open, onToggle }) {
  const { t } = useTranslation();
  const [medalsBySeason, setMedalsBySeason] = useState(null);
  const [titlesBySeason, setTitlesBySeason] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleToggle = async () => {
    if (!open && medalsBySeason === null) {
      setLoading(true);
      try {
        const medalsBySeason = await getMedalsBySeason(medals.season);
        setMedalsBySeason(medalsBySeason);

        const titlesBySeason = await getNationalTitlesBySeason(medals.season);
        setTitlesBySeason(titlesBySeason);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }

    onToggle();
  };

  return (
    <div className="medagliere-container">
      <div className="border-b border-gray-200">
        <button
          onClick={handleToggle}
          className="flex w-full items-center justify-between py-5 text-left contatti-faq-question"
          aria-expanded={open}
        >
          <span>
            {t("medagliere.season")} {medals.season}
          </span>
          {nationalTitles > 0 && (
            <span className="inline-flex items-center gap-3">
              <i className="fas fa-trophy fa-2x medal-national-title"></i>
              <span className="font-goldman-bold">{nationalTitles}</span>
            </span>
          )}
          <span className="inline-flex items-center gap-3">
            <i className="fas fa-medal fa-2x medal-gold"></i>
            <span className="font-goldman-bold">{medals.medals.Oro}</span>
          </span>
          <span className="inline-flex items-center gap-3">
            <i className="fas fa-medal fa-2x medal-silver"></i>
            <span className="font-goldman-bold">{medals.medals.Argento}</span>
          </span>
          <span className="inline-flex items-center gap-3">
            <i className="fas fa-medal fa-2x medal-bronze"></i>
            <span className="font-goldman-bold">{medals.medals.Bronzo}</span>
          </span>
          <span
            className={`base-title transition-transform duration-300 ease-out ${
              open ? "rotate-45" : "rotate-0"
            }`}
          >
            +
          </span>
        </button>

        <div
          className={`grid transition-[grid-template-rows] duration-300 ease-out ${
            open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
          }`}
        >
          <div className="overflow-hidden">
            <div
              className={`base-paragraph base-text-container transition-all duration-300 ease-out ${
                open ? "translate-y-0 opacity-100" : "-translate-y-1 opacity-0"
              }`}
            >
              {loading && <p className="base-text">Caricamento...</p>}
              {medalsBySeason && (
                <MedagliereDetail
                  medals={medalsBySeason}
                  titles={titlesBySeason}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MedagliereComponent;
